import { combineReducers, configureStore } from '@reduxjs/toolkit';

import ThemeReducer from '@redux/reducers/theme/theme.reducer';
import ExperienceReducer from '@redux/reducers/experience/experience.reducer';

const reducer = combineReducers({
  theme: ThemeReducer,
  experience: ExperienceReducer,
});

export const setStore = () =>
  configureStore({
    reducer,
  });

export type RootState = ReturnType<typeof reducer>;
export type RootStore = ReturnType<typeof setStore>;
export type RootDispatch = RootStore['dispatch'];
